import type { PrintToPDFOptions } from "electron";
import type { PrintSchema } from "@/utils/print/index";
import type { State as appSettingsStoreState } from "../store/appSettingsStore.init";
import type { State as userStoreState } from "../store/userStore.init";

export enum Bridge {
	Storage = "_electron_storage",
	Versions = "_electron_versions",
	PrintToPDF = "_electron_print_to_pdf",
	Window = "_electron_window",
	SafeStorage = "_electron_safeStorage",
	Store = "_electron_store",
	File = "_electron_file",
}

export enum Channel {
	StorageGetItem = "storage:getItem",
	StorageSetItem = "storage:setItem",
	StorageRemoveItem = "storage:removeItem",
	BrowserWindowId = "browserWindow:id",
	PrintToPDF = "print:pdf",
	WindowOpen = "window:open",
	WindowReload = "window:reload",
	WindowReplace = "window:replace",
	WindowClose = "window:close",
	WindowDestroy = "window:destroy",
	WindowSetColorScheme = "window:setColorScheme",
	WindowPrintToPDF = "window:printToPDF",
	WindowOpenDevTools = "window:openDevTools",
	SafeStorageEncryptString = "safeStorage:encryptString",
	SafeStorageDecryptString = "safeStorage:decryptString",
	StoreOnUpdate = "store:on:update",
	StoreDispatch = "store:dispatch",
	StoreGetState = "store:getState",
	FileShowOpenFilePicker = "file:showOpenFilePicker",
}

export interface BridgeApi {
	[Bridge.Storage]?: {
		getItem: (key: string) => Promise<string | null>;
		setItem: (key: string, value: string) => Promise<void>;
		removeItem: (key: string) => Promise<void>;
	};
	[Bridge.Versions]?: {
		node: () => string;
		chrome: () => string;
		electron: () => string;
		app: () => string;
	};
	[Bridge.PrintToPDF]?: (
		printSchema: PrintSchema,
		fileName?: string,
		options?: PrintToPDFOptions,
	) => void;
	[Bridge.Window]?: {
		open: (type: "main" | "login") => Promise<void>;
		reload: () => Promise<void>;
		replace: (target: "main" | "login") => Promise<void>;
		close: (type: "main" | "login") => Promise<void>;
		destroy: () => Promise<void>;
		setColorScheme: (schema: "light" | "dark") => Promise<void>;
		printToPDF: (
			fileName: string,
			options?: PrintToPDFOptions,
		) => Promise<void>;
		openDevTools: () => Promise<void>;
	};
	[Bridge.Store]?: {
		onUpdate?: (
			callback: (
				state: userStoreState & appSettingsStoreState,
				stateName: string,
			) => void,
		) => void;
		dispatch?: (
			state: userStoreState & appSettingsStoreState,
			stateName: string,
		) => Promise<void>;
		getState?: (
			storeName: string,
		) => Promise<userStoreState & appSettingsStoreState>;
	};
}
